export default {
  noTemplate: '',
  prosCons: '-----Pros----- \n\n\n -----Cons----- \n\n\n -----Suggestions-----\n',
};
